import config from "@/config"

export const state = {

    user: {},
    token: null,
    filter: false,
    title: '',
    method: "",
    warnTimeout: null,
    sessionTimeout: null,
    isShowSMSidebar: true,
    isBlock: false,
    //force block/not block
    forceBlock: true,
    changeTracker: false,
    linkHandling: null,
    response: null,
    // words:[],
    // params:[],
    // locales:[],
    isShowFormBuilderMenu:false,
    sidLogin:false,
    appLanguage: localStorage.getItem("appLanguage") || 'en',
    pipl: {
        'CNPIPL_1_AGREE': false,
        'CNPIPL_2_CONSENT': false,
        'CNPIPL_3_SENSITIVE': false,
        'CNPIPL_4_TRANSFER': false,
        'CNPIPL_5_3RD': false,
        'CNPIPL_6_OPTIN': false,
        'CNPIPL_7_DIRECT_OPTIN': false,
        'PIPL_CONSENT_VERSION': 'general', //minor || general
        'AGREE_MINOR': "0", // "0" || "1"
        'KDP_CNPIPL_1_AGREE': false,
        'KDP_CNPIPL_2_CONSENT': false,
        'KDP_CNPIPL_3_SENSITIVE': false,
        'KDP_CNPIPL_4_TRANSFER': false,
        'KDP_CNPIPL_5_3RD': false,
        'KDP_CNPIPL_6_OPTIN': false,
        'KDP_CNPIPL_7_DIRECT_OPTIN': false,
        'KDP_PIPL_CONSENT_VERSION': 'general', //minor || general
        'KDP_AGREE_MINOR': "0", // "0" || "1"
    },
    queryPara: "",
    isWechat: false,
    regData: {},

    unionId: "",
    k11_optin: 0,
    k11_aff_optin: 0,
    kdp_optin: 0,
    kdp_aff_optin: 0,
    openId: "",
    openType: "",
    k11_vipcode: "",
}

export const mutations = {
    setAppLanguage(state, language) {
        state.appLanguage = language;
        localStorage.setItem("appLanguage", language); // Whenever we change the appLanguage we save it to the localStorage
    },
    switchSidebar() {
        state.isShowSMSidebar = !state.isShowSMSidebar
    },
    linkHandling(state, obj) {
        state.linkHandling = obj;
    },
    resetLinkHandling(state) {
        state.linkHandling = null;
    },
    setChangeTracker() {
        state.changeTracker = !state.changeTracker
    },
    setForceBlock(state, forceBlock) {
        state.forceBlock = forceBlock;
    },
    // setWord(state,word){
    //     state.words = word;
    // },
    // setParams(state,params){
    //     state.params = params;
    // },
    // setLocales(state,locales){
    //     state.locales = locales;
    // },
    setBlock(state, isBlock) {
        state.isBlock = isBlock;

        if (state.isBlock && state.forceBlock) {
            NProgress.start();
            $('#mainWrapper').block({
                message: '<i class="icon-spinner2 spinner"></i>',
                overlayCSS: {
                    backgroundColor: 'none',
                    opacity: 0.8,
                    cursor: 'wait',
                    'box-shadow': '0 0 0 1px #ddd'
                },
                css: {
                    border: 0,
                    padding: 0,
                    backgroundColor: 'none'
                }
            })
        } else if (!state.isBlock && state.forceBlock) {
            NProgress.done();
            $('#mainWrapper').unblock();
        }
    },
    setUser(state, user) {
        window.localStorage.setItem(
            "ccrs_user",
            JSON.stringify(user)
        );



    },
    runMethod(state, { component, name }) {
        state.method = {
            component: component,
            name: name
        };
    },

    setResponse(state, { isSuccess, r, id }) {
        let obj = {
            success: isSuccess,
            r: r,
            id: id
        }
        state.response = obj;

    },


    setToken(state, token) {
        // state.token = token

        window.localStorage.setItem("ccrs_token", token)

    },
    setFilter(state, filter) {
        state.filter = filter
    },
    resetTimeout(state) {
        clearTimeout(state.warnTimeout)
        clearTimeout(state.sessionTimeout)

        state.warnTimeout = setTimeout(
            function () {
                $('#warnDialog').modal('show')
            }, config.sessionWarn * 60000
        )

        state.sessionTimeout = setTimeout(
            function () {
                $('#warnDialog').modal('hide')
                $('#timeoutDialog').modal('show')
            }, config.sessionTimeout * 60000
        )
    },
    setFormBuilderMenu(state,isShow){
        state.isShowFormBuilderMenu = isShow;
    },
    setSidLogin(state,sidLogin){
        state.sidLogin = sidLogin
    },
    setData(state, data) {
        state.regData = data
    },
    setQs(state, data) {
        state.queryPara = data
    },
    setIsWechat(state, data) {
        state.isWechat = data === true || data === "true"
        localStorage.setItem("isWechat", data)
    },
    setCustomPIPL(state, pipl){
        state.pipl = { ...state.pipl, ...pipl }
    },
    setPIPL(state, pipl) {
        switch (pipl) {
            case 'reset_values':
                state.pipl = {
                    ...state.pipl,
                    'CNPIPL_1_AGREE': false,
                    'CNPIPL_2_CONSENT': false,
                    'CNPIPL_3_SENSITIVE': false,
                    'CNPIPL_4_TRANSFER': false,
                    'CNPIPL_5_3RD': false,
                    'CNPIPL_6_OPTIN': false,
                    'CNPIPL_7_DIRECT_OPTIN': false,
                    'KDP_CNPIPL_1_AGREE': false,
                    'KDP_CNPIPL_2_CONSENT': false,
                    'KDP_CNPIPL_3_SENSITIVE': false,
                    'KDP_CNPIPL_4_TRANSFER': false,
                    'KDP_CNPIPL_5_3RD': false,
                    'KDP_CNPIPL_6_OPTIN': false,
                    'KDP_CNPIPL_7_DIRECT_OPTIN': false,
                }
                break
            case 'reset':
                state.pipl = {
                    'CNPIPL_1_AGREE': false,
                    'CNPIPL_2_CONSENT': false,
                    'CNPIPL_3_SENSITIVE': false,
                    'CNPIPL_4_TRANSFER': false,
                    'CNPIPL_5_3RD': false,
                    'CNPIPL_6_OPTIN': false,
                    'CNPIPL_7_DIRECT_OPTIN': false,
                    'PIPL_CONSENT_VERSION': 'general', //minor || general
                    'AGREE_MINOR': "0", // "0" || "1"
                    'KDP_CNPIPL_1_AGREE': false,
                    'KDP_CNPIPL_2_CONSENT': false,
                    'KDP_CNPIPL_3_SENSITIVE': false,
                    'KDP_CNPIPL_4_TRANSFER': false,
                    'KDP_CNPIPL_5_3RD': false,
                    'KDP_CNPIPL_6_OPTIN': false,
                    'KDP_CNPIPL_7_DIRECT_OPTIN': false,
                    'KDP_PIPL_CONSENT_VERSION': 'general', //minor || general
                    'KDP_AGREE_MINOR': "0", // "0" || "1"
                }
                break
            case 'general':
            case 'minor':
                state.pipl['PIPL_CONSENT_VERSION'] = pipl
                state.pipl['KDP_PIPL_CONSENT_VERSION'] = pipl
                break
            case 'AGREE_MINOR_on':
                state.pipl['AGREE_MINOR'] = '1'
                state.pipl['KDP_AGREE_MINOR'] = '1'
                break
            case 'AGREE_MINOR_off':
                state.pipl['AGREE_MINOR'] = '0'
                state.pipl['KDP_AGREE_MINOR'] = '0'
                break
            case 'AGREE_MINOR':
                state.pipl['AGREE_MINOR'] = state.pipl['AGREE_MINOR'] === '0' ? '1' : '0'
                state.pipl['KDP_AGREE_MINOR'] = state.pipl['KDP_AGREE_MINOR'] === '0' ? '1' : '0'
                break
            case 'CNPIPL_3_SENSITIVE':
                state.pipl['CNPIPL_2_CONSENT'] = !state.pipl['CNPIPL_2_CONSENT']
                state.pipl[pipl] = !state.pipl[pipl]
                break
            case 'KDP_CNPIPL_3_SENSITIVE':
                state.pipl['KDP_CNPIPL_2_CONSENT'] = !state.pipl['KDP_CNPIPL_2_CONSENT']
                state.pipl[pipl] = !state.pipl[pipl]
                break
            case 'CNPIPL_1_GROUP':
                let status = !state.pipl['CNPIPL_2_CONSENT'] || !state.pipl['CNPIPL_3_SENSITIVE'] || !state.pipl['CNPIPL_4_TRANSFER'] || !state.pipl['CNPIPL_5_3RD']
                state.pipl['CNPIPL_2_CONSENT'] = status
                state.pipl['CNPIPL_3_SENSITIVE'] = status
                state.pipl['CNPIPL_4_TRANSFER'] = status
                state.pipl['CNPIPL_5_3RD'] = status
                break
            case 'CNPIPL_2_GROUP':
                let status2 = !state.pipl['CNPIPL_6_OPTIN'] || !state.pipl['CNPIPL_7_DIRECT_OPTIN']
                state.pipl['CNPIPL_6_OPTIN'] = status2
                state.pipl['CNPIPL_7_DIRECT_OPTIN'] = status2
                break
            case 'KDP_CNPIPL_1_GROUP':
                let KDP_status = !state.pipl['KDP_CNPIPL_2_CONSENT'] || !state.pipl['KDP_CNPIPL_3_SENSITIVE'] || !state.pipl['KDP_CNPIPL_4_TRANSFER'] || !state.pipl['KDP_CNPIPL_5_3RD']
                state.pipl['KDP_CNPIPL_2_CONSENT'] = KDP_status
                state.pipl['KDP_CNPIPL_3_SENSITIVE'] = KDP_status
                state.pipl['KDP_CNPIPL_4_TRANSFER'] = KDP_status
                state.pipl['KDP_CNPIPL_5_3RD'] = KDP_status
                break
            case 'KDP_CNPIPL_2_GROUP':
                let KDP_status2 = !state.pipl['KDP_CNPIPL_6_OPTIN'] || !state.pipl['KDP_CNPIPL_7_DIRECT_OPTIN']
                state.pipl['KDP_CNPIPL_6_OPTIN'] = KDP_status2
                state.pipl['KDP_CNPIPL_7_DIRECT_OPTIN'] = KDP_status2
                break
            default:
                state.pipl = {...state.pipl, [pipl]: !state.pipl[pipl]}
        }
    },
    setWeChatQueryStringRelatedFields(state, {
        unionId, k11_optin, k11_aff_optin, kdp_optin, kdp_aff_optin,openId, openType,
        c1, c3, c4, c5, c6, c7,
        k1, k3, k4, k5, k6, k7
    }) {
        state.unionId = unionId ?? state.unionId
        state.openId = openId ?? state.openId
        state.openType = openType ?? state.openType
        state.k11_optin = k11_optin ?? state.k11_optin
        state.k11_aff_optin = k11_aff_optin ?? state.k11_aff_optin
        state.kdp_optin = kdp_optin ?? state.kdp_optin
        state.kdp_aff_optin = kdp_aff_optin ?? state.kdp_aff_optin
        state.pipl = {
            'CNPIPL_1_AGREE': c1 ? (c1 == "1" ? true : false) : state.pipl['CNPIPL_1_AGREE'],
            'CNPIPL_2_CONSENT': c1 ? (c1 == "1" ? true : false) : state.pipl['CNPIPL_1_AGREE'], //not in use, but K11 / KDP API required
            'CNPIPL_3_SENSITIVE': c3 ? (c3 == "1" ? true : false ) : state.pipl['CNPIPL_3_SENSITIVE'],
            'CNPIPL_4_TRANSFER': c4 ? (c4 == "1" ? true : false ) : state.pipl['CNPIPL_4_TRANSFER'],
            'CNPIPL_5_3RD': c5 ? (c5 == "1" ? true : false ) : state.pipl['CNPIPL_5_3RD'],
            'CNPIPL_6_OPTIN': c6 ? (c6 == "1" ? true : false ) : state.pipl['CNPIPL_6_OPTIN'],
            'CNPIPL_7_DIRECT_OPTIN': c7 ? (c7 == "1" ? true : false ) : state.pipl['CNPIPL_7_DIRECT_OPTIN'],
            'PIPL_CONSENT_VERSION': 'general', //minor || general
            'AGREE_MINOR': "0", // "0" || "1"
            'KDP_CNPIPL_1_AGREE': k1 ? (k1 == "1" ? true : false ) : state.pipl['KDP_CNPIPL_1_AGREE'],
            'KDP_CNPIPL_2_CONSENT': k1 ? (k1 == "1" ? true : false ) : state.pipl['KDP_CNPIPL_1_AGREE'], //not in use, but K11 / KDP API required
            'KDP_CNPIPL_3_SENSITIVE': k3 ? (k3 == "1" ? true : false ) : state.pipl['KDP_CNPIPL_3_SENSITIVE'],
            'KDP_CNPIPL_4_TRANSFER': k4 ? (k4 == "1" ? true : false ) : state.pipl['KDP_CNPIPL_4_TRANSFER'],
            'KDP_CNPIPL_5_3RD': k5 ? (k5 == "1" ? true : false ) : state.pipl['KDP_CNPIPL_5_3RD'],
            'KDP_CNPIPL_6_OPTIN': k6 ? (k6 == "1" ? true : false ) : state.pipl['KDP_CNPIPL_6_OPTIN'],
            'KDP_CNPIPL_7_DIRECT_OPTIN': k7 ? (k7 == "1" ? true : false ) : state.pipl['KDP_CNPIPL_7_DIRECT_OPTIN'],
            'KDP_PIPL_CONSENT_VERSION': 'general', //minor || general
            'KDP_AGREE_MINOR': "0", // "0" || "1"
        }
        localStorage.setItem("unionId", state.unionId)
        localStorage.setItem("k11_optin", state.k11_optin)
        localStorage.setItem("k11_aff_optin", state.k11_aff_optin)
        localStorage.setItem("kdp_optin", state.kdp_optin)
        localStorage.setItem("kdp_aff_optin", state.kdp_aff_optin)
        localStorage.setItem("openId", state.openId)
        localStorage.setItem("openType", state.openType)
        localStorage.setItem("pipl", JSON.stringify(state.pipl))
    },
    setK11VipCode(state, vipCode){
        state.k11_vipcode = vipCode
    }
}

export const actions = {
    actionSetSidLogin: ({ commit }, sidLogin) => {
        commit('setSidLogin', sidLogin);
    },
    actionSetUser: ({ commit }, user) => {
        commit('setUser', user);
    },
    actionSetToken: ({ commit }, token) => {
        commit('setToken', token);
    },
    actionSetFilter: ({ commit }, filter) => {
        commit('setFilter', filter);
    },
    actionLinkHandling: ({ commit }, obj) => {
        commit('linkHandling', obj);
    },
    actionSetForceBlock: ({ commit }, forceBlock) => {
        commit('setForceBlock', forceBlock);
    },
    actionResetTimeout: ({ commit }) => {
        commit('resetTimeout');
    },
    actionSetChangeTracker: ({ commit }) => {
        commit('setChangeTracker');
    },
    actionSwitchSidebar: ({ commit }) => {
        commit('switchSidebar');
    },
    actionSetBlock: ({ commit }, isBlock) => {
        commit('setBlock', isBlock);
    },
    actioResetlinkHandling: ({ commit }) => {
        commit('resetLinkHandling');
    },

    actioSetResponse: ({ commit }, { isSuccess, r, id }) => {
        commit('setResponse', { isSuccess, r, id })
    },
    actionSetFormBuilderMenu: ({ commit },isShow) => {
        commit('setFormBuilderMenu',isShow);
    },
    actionRetrieveWechatRelatedParams: ({ commit }) => {
        const isWechat = localStorage.getItem("isWechat") === "true"
        commit('setIsWechat', isWechat)
        if (isWechat){
            commit('setCustomPIPL', JSON.parse(localStorage.getItem("pipl")))
            const keys = [
                'unionId', 'k11_optin', 'k11_aff_optin', 'kdp_optin', 'kdp_aff_optin', 'openId', 'openType'
            ]
            const params = {}
            Promise.all(keys.map(key => {
            params[key] = localStorage.getItem(key)
            }))
            commit('setWeChatQueryStringRelatedFields', params)
        }
    },

}


export const getters = {
    getChangeTracker: state => state.changeTracker,
    getLinkHandling: state => state.linkHandling,
    getIsBlock: state => state.isBlock,
    getResponse: state => state.response,
    getVm: state => state.vm,
    getParams: state => state.params,
    getIsShowFormBuilderMenu: state => state.isShowFormBuilderMenu,
    getSidLogin: state => state.sidLogin,
    getAppLanguage: (state) => state.appLanguage,
    getPipl: (state) => (key) => {
        switch (key) {
            case "pipl":
                return Object.assign({}, ...Object.entries(state.pipl).map(([k, v]) => ({[k]:v === true ? "1" : v === false ? "0" : v})));
            case "AGREE_MINOR":
            case "PIPL_CONSENT_VERSION":
                return state.pipl[key]
            case "CNPIPL_1_GROUP":
                return state.pipl['CNPIPL_3_SENSITIVE'] && state.pipl['CNPIPL_4_TRANSFER'] && state.pipl['CNPIPL_5_3RD']
            case "CNPIPL_2_GROUP":
                return state.pipl['CNPIPL_6_OPTIN'] && state.pipl['CNPIPL_7_DIRECT_OPTIN']
            case "KDP_CNPIPL_1_GROUP":
                return state.pipl['KDP_CNPIPL_3_SENSITIVE'] && state.pipl['KDP_CNPIPL_4_TRANSFER'] && state.pipl['KDP_CNPIPL_5_3RD']
            case "KDP_CNPIPL_2_GROUP":
                return state.pipl['KDP_CNPIPL_6_OPTIN'] && state.pipl['KDP_CNPIPL_7_DIRECT_OPTIN']
            default:
                return state.pipl[key] === true
        }
    },
    getQs: (state)=> state.queryPara,
    isWechat: (state)=> state.isWechat,
    isSubmittable: (state, getters) => {
        return !getters.getPipl("CNPIPL_1_AGREE") || !getters.getPipl("KDP_CNPIPL_1_AGREE") || !getters.getPipl("CNPIPL_1_GROUP") || !getters.getPipl("KDP_CNPIPL_1_GROUP")
    },
    getUnionId: (state) => state.unionId,
}